/**
 * Handles the consent manager extension.
 *
 * @author Philipp Seiler <ps@typoheads.at>
 */
export default class ConsentManager {
  /**
   * Container of the banner action.
   *
   * @type {HTMLElement}
   * @private
   */
  private readonly bannerActionContainer: HTMLElement;


  constructor() {
    this.bannerActionContainer = document.querySelector('[data-extension="consent_manager"] [data-action="banner"]');
    if (this.bannerActionContainer) {
      this.initializeRejectAllButton();
    }
  }


  /**
   * Initializes the button to reject all features.
   *
   * @private
   */
  private initializeRejectAllButton() {
    if (!this.bannerActionContainer) {
      return;
    }

    const rejectAllButtons = this.bannerActionContainer.querySelectorAll('.reject-all');
    rejectAllButtons.forEach((button: HTMLElement) => {
      button.addEventListener('click', () => {
        ConsentManagerUtility.setBannerUsed(true);
        ConsentManagerUtility.disableAllFeatures();
        this.bannerActionContainer.classList.remove('show');
      });
    });
  }
}
